import { render, staticRenderFns } from "./ServiceCallsOverview.vue?vue&type=template&id=8f2a29cc"
import script from "./ServiceCallsOverview.vue?vue&type=script&lang=js"
export * from "./ServiceCallsOverview.vue?vue&type=script&lang=js"
import style0 from "./ServiceCallsOverview.vue?vue&type=style&index=0&id=8f2a29cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports